import { mapValues, omitBy } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { withProps } from 'recompose';
import Title from 'components/Title';
import FormGroup from 'components/form/Group';
import TypedBlockCollectionItem from 'components/form/TypedBlockCollectionItem';
import TypedCollection from 'components/form/TypedCollection';
import { useSettingsMemo } from 'components/sessions/useSettings';
import SCPI from './SCPI';

const SCPICollection = ({ required, namePrefix = 'data' }) => {
    const types = useSettingsMemo(({ simulation: { scpi: scpis } }) => {
        const scpiSimus = omitBy(({ deleted }) => deleted, scpis);

        return mapValues(({ name, ...scpi }) => ({
            component: withProps({ scpi })(SCPI),
            title: name,
            itemTitle: `${scpi.compagny} - ${name} - ${scpi.value}€`,
            unique: true,
            defaultValues: {
                parts: scpi.minimumParts,
                revaluation: '0',
            },
        }), scpiSimus);
    });

    return (
        <FormGroup>
            <Title><b>Produits {required ? '*' : ''}</b></Title>
            <TypedCollection
                name={`${namePrefix}.products`}
                types={types}
                textOnly
                itemComponent={TypedBlockCollectionItem}
                required={required}
            />
        </FormGroup>
    );
};

SCPICollection.propTypes = {
    required: PropTypes.bool,
    namePrefix: PropTypes.string,
};

export default SCPICollection;
